import { toggleEditorSidebar } from '~src/sidebarLegacy';
import { getState } from '~src/state';

export const hideSidebars = () => {
  if (getState('isSidebarOpen')) {
    toggleEditorSidebar();
  }
};
